export default __webpack_public_path__ + "static/media/ar2.8609d135.jpg";